

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"80","height":"80","viewBox":"0 0 80 80"}, rest), ["\n  ", h('path', {"fill":"#609AAC","d":"M40 0c22.091 0 40 17.909 40 40S62.091 80 40 80 0 62.091 0 40 17.909 0 40 0zm19.125 24.938a.604.604 0 0 0-.875 0L34.375 48.813 21.687 36.124a.604.604 0 0 0-.875 0L15.5 41.438a.604.604 0 0 0 0 .874L33.938 60.75c.25.25.624.25.874 0l29.626-29.625a.604.604 0 0 0 0-.875z"}, []), "\n"]);
};

        